import React from 'react';
import { Spin } from 'antd';
import { useIsMounted } from 'usehooks-ts';
import SimpleEditor from '../ESR/editor/texteditor/texteditor';

type RichTextEditorProps = {
  data?: string;
  onDataChange: (data: string) => void;
  readOnly: boolean;
};

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  data,
  onDataChange,
  readOnly
}) => {

  return (
    <div className="flex flex-col flex-1">
      <SimpleEditor
        initialData={data || ''}
        editable={!readOnly}
        onChange={onDataChange}
      />
    </div>
  );
};

export default RichTextEditor;
